import { render } from "./CreateClientPage.vue?vue&type=template&id=3c7adf67"
import script from "./CreateClientPage.vue?vue&type=script&lang=js"
export * from "./CreateClientPage.vue?vue&type=script&lang=js"

import "@/css/CreateClientPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__